import InputComponentMixin from '../../mixins/input/input_component_mixin.jsx';

var createClass = require('create-react-class');

window.InputHidden = createClass({
  mixins: [InputComponentMixin],

  render: function() {
    return (
      <input {...this.props} type="hidden" ref="input" />
    );
  }
});
